var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import buildPlanDisplay from './buildPlanDisplay';
import addPlanUpgrade from './addPlanUpgrade';
import { getKeyByValue, planDisplayToggle } from './helperFunctions';
import AppState from '../AppState';
/**
 * Processes plans with upgrades.
 *
 * @param {AvailableSelections} plan - The selected plan.
 * @param {AvailableSelections[]} allPlans - All available plans.
 * @returns {AvailableSelections[]} - Sorted plans with upgrades.
 */
const processPlansWithUpgrades = (plan, allPlans) => {
    var _a;
    // Loops over filtered options to create non-standard plans
    const planId = AppState.get('planId');
    const sfpModel = AppState.get('serviceFunnelPackage');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context } = drupalJsObjects;
    const planUpgrades = allPlans.map(option => addPlanUpgrade(option, plan));
    const fibreUpgrade = planUpgrades.some(upgrade => upgrade.showFibreUpgrade === true);
    const serviceAvailable = context.querySelector('#service-available');
    if (serviceAvailable) {
        const serviceType = getKeyByValue(sfpModel.serviceType);
        if (!fibreUpgrade && ['FTTN', 'FTTC', 'FTTB'].includes(serviceType)) {
            const upgradeAvailability = context.querySelector('#upgrade-availability');
            upgradeAvailability.innerHTML = Drupal.t(`We can't confirm your line speeds until your service is activated on the iPrimus nbn™ network. If your iPrimus nbn™ connection doesn't allow you to properly benefit from the speed tier you're on, we'll provide you with your maximum line speed and alternative options. Already an iPrimus customer? Please call <a href="tel:131789">13 17 89</a>`);
        }
        // Logic to display plans with upgrades.
        if (planUpgrades.length > 0) {
            const sortedPlans = planUpgrades.sort((a, b) => a.price - b.price);
            const selectedPlanPrice = (_a = sortedPlans.find(plan => plan.PlanIdentifier === planId)) === null || _a === void 0 ? void 0 : _a.price;
            (() => __awaiter(void 0, void 0, void 0, function* () {
                for (const plan of sortedPlans) {
                    const { PlanIdentifier, nodeData } = plan;
                    const node = yield nodeData;
                    // Ensure only upsells are visible to FOD eligible addresses.
                    if (fibreUpgrade && (parseInt(node.data[0].attributes.field_plan_monthly_fee, 10) < selectedPlanPrice)) {
                        continue;
                    }
                    // Add badge to upgrade option.
                    const badges = [];
                    badges.push(Drupal.t('Available'));
                    if (node.data[0].attributes.field_plan_callout_text !== null) {
                        badges.push(Drupal.t(node.data[0].attributes.field_plan_callout_text));
                    }
                    // Add badge to selected plan and skip so not to duplicate.
                    if (node.data[0].attributes.field_plan_id === planId) {
                        const badgeContainer = context.querySelector(`#offer-badges-${planId}`);
                        if (['SBCHRG9', 'SBCHRG11'].includes(planId)) {
                            const serviceType = getKeyByValue(sfpModel.serviceType);
                            if (['FTTN', 'FTTC'].includes(serviceType)) {
                                badges.push(Drupal.t('Free Fibre upgrade'));
                            }
                        }
                        if (badges.length > 0) {
                            badges.forEach(badge => {
                                const li = document.createElement('li');
                                li.classList.add('badge');
                                li.innerHTML = badge;
                                badgeContainer.appendChild(li);
                            });
                        }
                        continue;
                    }
                    if (['SBCHRG11', 'SBCHRG9'].includes(plan.PlanIdentifier)) {
                        const serviceType = getKeyByValue(sfpModel.serviceType);
                        if (['FTTN', 'FTTC'].includes(serviceType)) {
                            badges.push(Drupal.t('Free Fibre upgrade'));
                        }
                    }
                    buildPlanDisplay(PlanIdentifier, node, badges, 0);
                }
                if (fibreUpgrade) {
                    const upgradeAvailability = context.querySelector('#upgrade-availability');
                    const upgradeMessages = context.querySelector('#upgrade-messages');
                    if (planId !== 'SBCHRG11') {
                        upgradeMessages.innerHTML = `
              <p class="great-news--title">${Drupal.t('Get free fibre upgrade')}</p>
              <p class="great-news--text">${Drupal.t('Great news, your address qualifies for a complementary upgrade to Fibre to the Premise (FTTP) on selected plans. Find out more about <a href="#" data-bs-target="#nbn-upgrades" data-bs-toggle="modal">NBN Fibre upgrades</a>.')}</p>
            `;
                    }
                    if (planId !== 'SBCHRG7') {
                        upgradeAvailability.innerHTML = Drupal.t('Plus, here’s some exciting news, your address qualifies for a complementary upgrade to Fibre to the Premise (FTTP) on selected plans. Find out more about <a href="#" data-bs-target="#nbn-upgrades" data-bs-toggle="modal">NBN Fibre upgrades</a>.');
                    }
                }
                else {
                    planDisplayToggle(serviceAvailable);
                }
            }))();
            return sortedPlans;
        }
    }
    return [];
};
export default processPlansWithUpgrades;
